<template>
  <div>
    <div class="subheading">{{ label }}</div>
    <ul>
      <li v-for="(item, index) in model" :key="index">{{ item }}</li>
    </ul>
    {{ description }}
    <v-divider class="multiple-divider" />
    <v-text-field
      class="d-inline-block new-value-input"
      v-model="newValue"
      :label="`${$t('form.inputs.multiple.new-value')}`"
    ></v-text-field>
    <v-btn @click="pushElement">{{ $t('form.inputs.multiple.push') }}</v-btn>
    <v-btn @click="popElement">{{ $t('form.inputs.multiple.pop') }}</v-btn>
  </div>
</template>

<script>
import { input } from '@/mixins/input'

export default {
  mixins: [ input ],
  data() {
    return {
      newValue: "",
    }
  },
  created() {
    this.model = this.value || []
  },
  methods: {
    beforeSend(val) {
      return val
    },
    pushElement() {
      this.model.push(this.newValue)
      this.newValue = ""
    },
    popElement() {
      this.model.pop()
    }
  },
}
</script>

<style>
.multiple-divider {
  margin-top: 13px;
}
.new-value-input {
  margin-left: 10px;
}
</style>
